import { useEffect, useState } from 'react';

const useYoutube = () => {
    const [videoDuration, setVideoDuration] = useState(null);
    const [error, setError] = useState(null);

    const getVideoDuration = async (videoId) => {
        try {
            const res = await fetch(`/api/youtube/get-duration?videoId=${videoId}`);
            const data = await res.json();

            if (data.duration) {
                const parsed = parseDuration(data.duration);
                setVideoDuration(parsed);
                return parsed;
            } else {
                setError("No duration found.");
                return 'Error';
            }
        } catch (err) {
            setError("Failed to fetch video duration.");
            return 'Error';
        }
    };

    const parseDuration = (durationString) => {
        const duration = { hours: 0, minutes: 0, seconds: 0 };
        const durationParts = durationString
            .replace("PT", "")
            .replace("H", ":")
            .replace("M", ":")
            .replace("S", "")
            .split(":");

        if (durationParts.length === 3) {
            [duration.hours, duration.minutes, duration.seconds] = durationParts;
        } else if (durationParts.length === 2) {
            [duration.minutes, duration.seconds] = durationParts;
        } else if (durationParts.length === 1) {
            [duration.seconds] = durationParts;
        }

        return `${duration.minutes}:${duration.seconds.toString().padStart(2, '0')}`;
    };

    return { getVideoDuration, videoDuration, error };
};

export default useYoutube;
